import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  children: ReactNode;
  className?: string;
  /** When set the card renders as a link: focusable, Enter-activated, ⌘-clickable. */
  href?: string;
}

const base =
  'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-card';

const interactive =
  'block hover:shadow-card-hover hover:border-gray-300 dark:hover:border-gray-600 ' +
  'transition-[box-shadow,border-color] focus:outline-none focus-visible:ring-2 ' +
  'focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-50 ' +
  'dark:focus-visible:ring-offset-gray-900';

export function Card({ children, className = '', href }: Props) {
  if (href) {
    return (
      <Link to={href} className={`${base} ${interactive} ${className}`}>
        {children}
      </Link>
    );
  }

  return <div className={`${base} ${className}`}>{children}</div>;
}
